// extracted by mini-css-extract-plugin
export var checkbox = "_3x-0";
export var circle = "_3x-3";
export var horizontalContainer = "_3x-7";
export var sm = "_3x-5";
export var switch0 = "_3x-2";
export var switchDisabled = "_3x-8";
export var switchEnabled = "_3x-1";
export var textSwitchContainer = "_3x-9";
export var textSwitchOption = "_3x-a";
export var textSwitchOptionSelected = "_3x-b";
export var verticalContainer = "_3x-6";
export var xs = "_3x-4";